import { render, staticRenderFns } from "./PersonaTag.vue?vue&type=template&id=20c53a04&scoped=true&lang=pug&"
import script from "./PersonaTag.vue?vue&type=script&lang=ts&"
export * from "./PersonaTag.vue?vue&type=script&lang=ts&"
import style0 from "./PersonaTag.vue?vue&type=style&index=0&id=20c53a04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c53a04",
  null
  
)

component.options.__file = "PersonaTag.vue"
export default component.exports